//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../Assemblies/Assemblies.SelectComponentList.js";
import "../no/SelectBodyList.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AdjustMethod",1,0],[0,"AdjustVector",1,"Direction",0],[0,"AlongAxialDir",1,0],[1,"BaffleComponent",0,"Assemblies.SelectComponentList",0],[1,"BoundaryBody",0,"SelectBodyList",0],[0,"BoundaryObjects",0,"ScCollector",0],[0,"CopyOriginal",1,0],[1,"Diameter",0,"Expression",0],[0,"DiameterListValue",1,0],[1,"Distance",0,"Expression",0],[1,"ReferenceFace",0,"ScCollector",0],[0,"RemoveParameter",1,0],[0,"RepositionMethod",1,0],[1,"TargetChannel",0,"SelectBodyList",0]],[[["moveOrigin"],"SetManipulatorOriginValue",{},1,0],[["modified"],"SetModifyManipulatorOrigin",{},1,0]],[]];
SPLM.Tooling.ChannelAdjustBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.ChannelAdjustBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.ChannelAdjustBuilder.AdjustType = Object.freeze({
    "Distance" : "Distance", "BaffleLength" : "BaffleLength", "BaffleComponentLength" : "BaffleComponentLength", "AdjustDiameter" : "AdjustDiameter"});

SPLM.Tooling.ChannelAdjustBuilder.MoveType = Object.freeze({
    "MoveOriginal" : "MoveOriginal", "CopyOriginal" : "CopyOriginal"});

SPLM.Tooling.ChannelAdjustBuilder.VectorMethod = Object.freeze({
    "Along" : "Along", "Perpendicular" : "Perpendicular"});

export default SPLM;